<hr class=" row solid mb-0">
<!--<div class="bg-lightorange p-0" >&nbsp;</div>-->
<br>
  <div class="row"> </div> <!--row ends-->

  <div class="row">  
    <div class="col-md-12 col-lg-3 mb-2  align-items-stretch ">  
      <!--<div class="text-blue-bold">SmartBot</div><br>-->
      <img src="./assets/img/nexsharp.png" alt="nexrpa logo" width="200px"> 
      <div class="text-orange"> 
        <div>©2026 Nexsharp Technology.</div>
        <div >
          <a href="https://www.youtube.com/" target="_blank" style="color: red;"><i class="fab  fa-youtube fa-lg"></i></a>&nbsp;
          <!--<a href="#" ><i class="fab fa-instagram fa-lg"></i></a>&nbsp;-->
          <a href="https://github.com/" target="_blank" style="color: #333;"><i class="fab fa-github fa-lg"></i></a>&nbsp;          
          <a href="https://in.linkedin.com/" target="_blank" style="color: #0e76a8;"><i class="fab fa-linkedin-in fa-lg"></i></a>&nbsp;
          <a href="https://www.facebook.com/" target="_blank" style="color: #3b5998;"><i class="fab fa-facebook fa-lg"></i></a>&nbsp;
          <a href="https://twitter.com/" target="_blank" style="color: #1DA1F2;"><i class="fab fa-twitter fa-lg"></i></a>&nbsp;
          <span><img src="./assets/img/make-in-india.png" alt="Make in India" width="120px"></span>&nbsp;
        </div>
      </div>
    </div>
  </div>
